<div class="dialog">
    <div class="dialog-header">
        <h2>{{ 'technicals.tokens.dialog.success.title' | translate }}</h2>
        <a class="dialog-close" (click)="onClose()">&times;</a>
    </div>
    <div class="dialog-body">
        <div class="alert alert-warning">
            <i class="i i-warning"></i>
            <strong>{{ 'technicals.tokens.dialog.success.warning-title' | translate }}</strong>
            {{ 'technicals.tokens.dialog.success.warning-text-token' | translate }}<br>
            {{ 'technicals.tokens.dialog.success.warning-text-copy' | translate }}

        </div>

        <div class="form-row">
            <label>{{ 'shared.table.type' | translate }}</label>
            <input type="text" readonly [value]="'technicals.tokens.role.' + token.role | translate" class="readonly-field">
        </div>

        <div class="form-row">
            <label>{{ 'shared.table.description' | translate }}</label>
            <input type="text" readonly [value]="token.comment || '—'" class="readonly-field">
        </div>

        <div class="form-row">
            <label>{{ 'technicals.tokens.dialog.success.api-key' | translate }}</label>
            <input
                type="text"
                readonly
                [value]="token.access_token"
                class="token-field"
                spellcheck="false"
                onclick="this.select()">
        </div>

        <div class="buttons buttons-flex">
            <a class="button button-basic-primary" (click)="onCopy()">
                <i class="i i-duplicate"></i> {{ 'technicals.tokens.button.copy' | translate }}
            </a>
            <a class="button button-primary" (click)="onClose()">{{ 'shared.button.close' | translate }}</a>
        </div>
    </div>
</div>
